<link
  href="https://fonts.googleapis.com/icon?family=Material+Icons"
  rel="stylesheet"
/>
<!-- <loading [isLoading]="isLoading" isFullSize="true"></loading> -->

<div *ngIf="IsAuthenticated">

  <div *ngIf="'Tablero' | permissionFilter" style="margin-left: 5em;" class="tableau">
    <tableau-report class="report"></tableau-report>
  </div>

  <div *ngIf="!('Tablero' | permissionFilter)" style="padding-top: 4.5em; margin-left: 5em;">
    <h2 class="welcome-title">Mapix - Sistema de Seguimiento Geoespacial</h2>
    <div class="div-welcome-text"><p class="welcome-text">Bienvenido a la plataforma de seguimiento en tiempo real para monitoreo y seguimiento de flotillas más usado en los ultimos tiempos</p></div>
  </div>
</div>